module App.Classes {
    export class Date implements App.Interfaces.IDate {
        date: any;
        available: number;
        discount: number;
    }
}